import React, { useMemo } from 'react';
import { FormCardDefaultHeader, FormCard, FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { ColorRegular } from '@fluentui/react-icons';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { Body1Strong, mergeClasses } from '@fluentui/react-components';
import { useStyles } from './style';
import {
  AdsStudioColorPickerProps
} from './type';
import { BrandColors, ColorAddButton } from './Palette';
import { PaletteSkeleton } from './PaletteSkelton';
import { useCheckDuplicateColor } from './hooks';


// WILL CHANGE ID ONCE DATA START COMING FROM API
const AdsStudioColorPicker: React.FC<AdsStudioColorPickerProps> = ({
  title,
  subTitle,
  text,
  isLoading,
  i18n,
  allowDuplicates,
  showEditBtn = true,
  defaultSelected,
  paletteData = [],
  maxColors = 2,
  helpTopic,
  helpLabel,
  onUpdate,
  onDelete,
}) => {
  const totalColors = paletteData.length;
  const { isDuplicate, onUpdateColor } = useCheckDuplicateColor({ paletteData, allowDuplicates, onUpdate });
  const classes = useStyles();

  const renderHelpBubble = useMemo(() => (
    <>
      {helpTopic && <HelpButton topic={helpTopic} aria-label={helpLabel} />}
    </>
  ), [helpLabel, helpTopic]);

  return (
    <div
      className={mergeClasses('brand_color_picker', classes.adsStudioColorPicker)}
    >
      <FormCard error="" className="brandkit-color-picker">
        <FormCardDefaultHeader
          title={title}
          contentAfter={renderHelpBubble}
          contentBefore={<ColorRegular className="color_icon" />}
        />
        <FormCardBody>
          <div className="list-body-header">
            <Body1Strong>{subTitle}</Body1Strong>
            {text && <p>{text}</p>}
          </div>
          {isLoading ?
            <PaletteSkeleton /> :
            <div className={mergeClasses('color_palette', classes.adsStudioColorPalette)}>
              {paletteData.map(colorData => (
                colorData && <BrandColors isDuplicate={isDuplicate} showEditBtn={showEditBtn} defaultSelected={defaultSelected} i18n={i18n} key={colorData.Name} colorData={colorData} onDelete={onDelete} updateColor={onUpdateColor} />
              ))}
              {(totalColors < maxColors) && <ColorAddButton isDuplicate={isDuplicate} totalColors={totalColors} i18n={i18n} updateColor={onUpdateColor} />}
            </div>
          }
        </FormCardBody>
      </FormCard>
    </div>
  );
};

const MemoizedAdsStudioColorPicker = React.memo(AdsStudioColorPicker);
export default MemoizedAdsStudioColorPicker;
